'use strict';

var Webapi__Dom__Types = require("./Webapi__Dom__Types.bs.js");

function Impl(T) {
  var eventPhase = function (self) {
    return Webapi__Dom__Types.EventPhase.decode(self.eventPhase);
  };
  return {
          eventPhase: eventPhase
        };
}

function eventPhase(self) {
  return Webapi__Dom__Types.EventPhase.decode(self.eventPhase);
}

exports.Impl = Impl;
exports.eventPhase = eventPhase;
/* No side effect */
